import type { StateType } from '../../lib/types/state-type';
import { setActiveLanguage } from '@dh-software/i18n';

export function changeLanguage(state: StateType, parameters: unknown[]): StateType {
  const language = parameters[0] as string;
  setActiveLanguage(language);
  return { ...state, language: language };
}
